<template>
  <div>
    <div class="flex flex-wrap -mx-2 mb-6">
      <!-- CAMPAIGN NAME -->
      <div class="w-full md:w-1/2 lg:w-1/3 px-2">
        <div>
          <label for="name">Digital Magazine Name:</label>
          <input type="text" id="name" v-model="form.name"
            class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
            :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('name') }">
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('name')"
            v-text="errorBag.get('name')"></small>
        </div>
      </div>

      <div class="w-full md:w-1/2 lg:w-2/3 px-2">
        <div class="flex justify-end">
          <button @click="showDeleteModal = true" class="bg-white hover:bg-grey text-primary py-2 px-6 text-sm border border-grey-dark rounded shadow whitespace-no-wrap">
            <i class="fas fa-trash-alt"></i> Delete Campaign
          </button>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-2 border-t pt-6">
      <div class="w-full md:w-1/2 lg:w-1/3 px-2">
        <!-- URL -->
        <div class="mb-6">
          <label for="url">Direct URL:</label>
          <div class="flex bg-grey-lighter border mt-2 text-sm items-stretch">
            <input type="text" id="url" v-model="form.url" disabled
              class="block w-full p-2" />
            <a :href="form.url" target="_blank" class="hover:bg-grey-light px-3 text-grey-darkest flex items-center no-underline border-l">
              <i class="fas fa-external-link-alt"></i>
            </a>
          </div>
          <small class="leading-none">This is the URL that should be used when linking to this campaign. It will always display the latest, approved edition of the e-zine.</small>
        </div>

        <!-- DESCRIPTION -->
        <div class="mb-6">
          <label for="description">Description:</label>
          <textarea id="description" v-model="form.description" rows="5"
            class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm"
            :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('description') }"></textarea>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('description')"
            v-text="errorBag.get('description')"></small>
        </div>

        <!-- DEFAULT VIEW -->
        <div class="mb-6">
          <label for="default_view_id">Default Display Mode:</label>
          <select id="default_view_id" v-model="form.default_view_id" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('default_view_id') }">
            <option :value="0">Presentation</option>
            <option :value="1">Magazine</option>
          </select>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('default_view_id')" v-text="errorBag.get('default_view_id')"></small>
        </div>

        <!-- WEBSITE URL -->
        <div class="mb-6">
          <label for="website_url">Website URL:</label>
          <input type="text" id="website_url" v-model="form.website_url"
            class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
            :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('website_url') }">
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('website_url')"
            v-text="errorBag.get('website_url')"></small>
        </div>

        <!-- Title Options -->
        <div class="mb-6">
          <label for="title_display_type_id">Title Options:</label>
          <select id="title_display_type_id" v-model="form.title_display_type_id" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('title_display_type') }">
            <option :value="0">Use Office Name</option>
            <option :value="1">Use Office Location</option>
            <option :value="2">Hide</option>
          </select>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('title_display_type_id')" v-text="errorBag.get('title_display_type')"></small>
        </div>

        <div class="mb-6">
          <input type="checkbox" id="enable_view_on_website_link" v-model="form.enable_view_on_website_link">
          <label for="enable_view_on_website_link">Enable view on our website link</label>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('enable_view_on_website_link')"
            v-text="errorBag.get('enable_view_on_website_link')"></small>
        </div>
        <div class="border p-3 bg-grey-lightest mb-6 rounded">
          <h4 class="mb-3">Call to Action</h4>
          <p class="mb-6 mt-2 text-sm text-grey-darker">The call to action appears on the property details popup. A URL is required to make the CTA visible.</p>

          <!-- CTA TITLE -->
          <div class="mb-6">
            <label for="cta_title">Title:</label>
            <input type="text" id="cta_title" v-model="form.cta_title"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('cta_title') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('cta_title')"
              v-text="errorBag.get('cta_title')"></small>
          </div>

          <!-- CTA BODY -->
          <div class="mb-6">
            <label for="cta_body">Message:</label>
            <textarea id="cta_body" v-model="form.cta_body"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('cta_body') }" rows="3"></textarea>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('cta_body')"
              v-text="errorBag.get('cta_body')"></small>
          </div>

          <!-- CTA ACTION -->
          <div class="mb-6">
            <label for="cta_action">Button Label:</label>
            <input type="text" id="cta_action" v-model="form.cta_action"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('cta_action') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('cta_action')"
              v-text="errorBag.get('cta_action')"></small>
          </div>

          <!-- CTA URL -->
          <div>
            <label for="cta_url">URL:</label>
            <input type="text" id="cta_url" v-model="form.cta_url"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('cta_url') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('cta_url')"
              v-text="errorBag.get('cta_url')"></small>
          </div>
        </div>
      </div>

      <div class="w-full md:w-1/2 lg:w-1/3 px-2">
        <div>
          <!-- PROOFING EMAIL ADDRESSES -->
          <div class="p-3 bg-yellow-lightest border rounded mb-6">
            <div class="mb-6">
              <h4 class="mb-3">Proofing Email Addresses</h4>
              <p class="mb-6 mt-2 text-sm text-grey-darker">Proofs will be sent to the addresses provided below for approval.</p>
              <div class="flex mt-2">
                <input type="email" v-model="newProofingAddress"
                  class="block w-full bg-white border hover:border-grey focus:border-grey-dark p-2 text-sm"
                  @keyup.enter="addProofingAddress">
                <button @click="addProofingAddress" title="Add Proofing Address"
                  class="h-full p-3 bg-grey-light hover:bg-grey">
                  <i class="fas fa-plus fa-fw"></i>
                </button>
              </div>
            </div>

            <table class="w-full">
              <tr v-for="(address, i) in form.proofing_email_addresses" :key="i">
                <td class="py-2">
                  {{ address }}
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get(`proofing_email_addresses.${i}`)"
                    v-text="errorBag.get(`proofing_email_addresses.${i}`)"></small>
                </td>
                <td class="text-right py-2">
                  <i class="fas fa-trash-alt hover:text-red-dark cursor-pointer" title="Remove Proofing Address"
                    @click="removeProofingAddress(address)"></i>
                </td>
              </tr>
            </table>
          </div>

          <!-- AUTO APPROVAL -->
          <div class="mb-6">
            <input type="checkbox" id="auto_approval_enabled" v-model="form.auto_approval_enabled">
            <label for="auto_approval_enabled" style="white-space: normal">Automatically approve new editions after 72 hours if no explicit approval is provided.</label>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('auto_approval_enabled')"
              v-text="errorBag.get('auto_approval_enabled')"></small>
          </div>

          <!-- RECIPIENTS -->
          <div class="p-3 bg-yellow-lightest border rounded mb-6">
            <div class="mb-6">
              <h4 class="mb-3">Recipients</h4>
              <p class="mb-6 mt-2 text-sm text-grey-darker">This is the list of email addresses to send the finalised ezines to. These emails should be forwarded on through your email marketing system, rather than listing all end users here.</p>
              <div class="flex mt-2">
                <input type="email" v-model="newRecipient"
                  class="block w-full bg-white border hover:border-grey focus:border-grey-dark p-2 text-sm"
                  @keyup.enter="addRecipient">
                <button @click="addRecipient" title="Add Recipient"
                  class="h-full p-3 bg-grey-light hover:bg-grey">
                  <i class="fas fa-plus fa-fw"></i>
                </button>
              </div>
            </div>

            <table class="w-full">
              <tr v-for="(address, i) in form.recipients" :key="i">
                <td class="py-2">
                  {{ address }}
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get(`recipients.${i}`)"
                    v-text="errorBag.get(`recipients.${i}`)"></small>
                </td>
                <td class="text-right py-2">
                  <i class="fas fa-trash-alt hover:text-red-dark cursor-pointer" title="Remove Recipient"
                    @click="removeRecipient(address)"></i>
                </td>
              </tr>
            </table>
          </div>

          <!-- FACEBOOK URL -->
          <div class="mb-6">
            <label for="social_facebook">Facebook URL:</label>
            <input type="text" id="social_facebook" v-model="form.social_facebook"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('social_facebook') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('social_facebook')"
              v-text="errorBag.get('social_facebook')"></small>
          </div>

          <!-- TWITTER URL -->
          <div class="mb-6">
            <label for="social_twitter">X URL:</label>
            <input type="text" id="social_twitter" v-model="form.social_twitter"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('social_twitter') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('social_twitter')"
              v-text="errorBag.get('social_twitter')"></small>
          </div>

          <!-- LINKEDIN URL -->
          <div class="mb-6">
            <label for="social_linkedin">LinkedIn URL:</label>
            <input type="text" id="social_linkedin" v-model="form.social_linkedin"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('social_linkedin') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('social_linkedin')"
              v-text="errorBag.get('social_linkedin')"></small>
          </div>

          <!-- INSTAGRAM URL -->
          <div class="mb-6">
            <label for="social_instagram">Instagram URL:</label>
            <input type="text" id="social_instagram" v-model="form.social_instagram"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('social_instagram') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('social_instagram')"
              v-text="errorBag.get('social_instagram')"></small>
          </div>

          <!-- YOUTUBE URL -->
          <div class="mb-6">
            <label for="social_youtube">YouTube URL:</label>
            <input type="text" id="social_youtube" v-model="form.social_youtube"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('social_youtube') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('social_youtube')"
              v-text="errorBag.get('social_youtube')"></small>
          </div>

          <!-- PINTEREST URL -->
          <div class="mb-6">
            <label for="social_pinterest">Pinterest URL:</label>
            <input type="text" id="social_pinterest" v-model="form.social_pinterest"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('social_pinterest') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('social_pinterest')"
              v-text="errorBag.get('social_pinterest')"></small>
          </div>

          <!-- TIKTOK URL -->
          <div class="mb-6">
            <label for="social_tiktok">TikTok URL:</label>
            <input type="text" id="social_tiktok" v-model="form.social_tiktok"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
              :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('social_tiktok') }">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('social_tiktok')"
              v-text="errorBag.get('social_tiktok')"></small>
          </div>
        </div>
      </div>

      <div class="w-full md:w-1/2 lg:w-1/3 px-2">
        <div>
          <!-- COMPANY LOGO -->
          <div class="mb-6 flex flex-col">
            <label class="mb-2">Logo:</label>
            <div class="flex flex-col items-center">
              <img v-if="form.logo" :src="form.logo" alt="Campaign Logo" class="mb-6 max-w-full" style="max-height: 100px;" />
              <div class="mb-6" v-else>
                Logo not selected
              </div>
              <button class="bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow whitespace-no-wrap" @click="$refs.mediaManager.open()">
                Change Logo
              </button>
            </div>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('logo')"
              v-text="errorBag.get('logo')"></small>
          </div>

          <!-- BACKGROUND COLOUR -->
          <div class="mb-6">
            <div class="flex flex-wrap -mx-2">
              <div class="w-full md:w-1/2 px-2">
                <div>
                  <label for="bg_colour">Background Colour:</label>
                  <div class="flex mt-2">
                    <input type="text" id="bg_colour" v-model.lazy="form.bg_colour"
                      class="block bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm w-full"
                      :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('bg_colour') }">
                    <div class="w-10" :style="{backgroundColor: form.bg_colour}"></div>
                  </div>
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('bg_colour')"
                    v-text="errorBag.get('bg_colour')"></small>
                </div>
              </div>
            </div>
          </div>

          <!-- COLOUR 1 -->
          <div class="mb-6">
            <div class="flex flex-wrap -mx-2">
              <div class="w-full md:w-1/2 px-2">
                <div>
                  <label for="colour1">Primary Colour:</label>
                  <div class="flex mt-2">
                    <input type="text" id="colour1" v-model.lazy="form.colour1"
                      class="block bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm w-full"
                      :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('colour1') }">
                    <div class="w-10" :style="{backgroundColor: form.colour1}"></div>
                  </div>
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('colour1')"
                    v-text="errorBag.get('colour1')"></small>
                </div>
              </div>

              <div class="w-full md:w-1/2 px-2">
                <div>
                  <label for="colour2">Secondary Colour:</label>
                  <div class="flex mt-2">
                    <input type="text" id="colour2" v-model.lazy="form.colour2"
                      class="block bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm w-full"
                      :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('colour2') }">
                    <div class="w-10" :style="{backgroundColor: form.colour2}"></div>
                  </div>
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('colour2')"
                    v-text="errorBag.get('colour2')"></small>
                </div>
              </div>
            </div>
          </div>

          <!-- FONTS -->
          <div class="mb-3">
            <label for="font_headings">Heading Font:</label>
            <div class="flex">
              <select id="font_headings" v-model="form.font_headings" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('font_headings') }">
                <option v-for="font in fonts" :key="font" :value="font">
                  {{ font }}
                </option>
              </select>

              <select id="font_headings_weight" v-model="form.font_headings_weight" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('font_headings_weight') }">
                <option v-for="weight in fontWeights" :key="weight.value" :value="weight.value">
                  {{ weight.name }}
                </option>
              </select>
            </div>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('font_headings')" v-text="errorBag.get('font_headings')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('font_headings_weight')" v-text="errorBag.get('font_headings_weight')"></small>
          </div>
          <div class="mb-6">
            <input type="checkbox" id="font_headings_uppercase" v-model="form.font_headings_uppercase">
            <label for="font_headings_uppercase">Uppercase Headings</label>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('font_headings_uppercase')"
              v-text="errorBag.get('font_headings_uppercase')"></small>
          </div>

          <!-- FONTS -->
          <div class="mb-6">
            <label for="font_body">Body Font:</label>
            <select id="font_body" v-model="form.font_body" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('font_body') }">
              <option v-for="font in fonts" :key="font" :value="font">
                {{ font }}
              </option>
            </select>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('font_body')" v-text="errorBag.get('font_body')"></small>
          </div>

          <h4 class="mb-3">Theme Preview</h4>
          <div class="rounded p-3" :style="{backgroundColor: form.colour2}">
            <iframe class="w-full border-0" style="height: 270px" :srcdoc="themePreview" scrolling="no"></iframe>
          </div>
        </div>
      </div>
    </div>

    <ezine-media-manager ref="mediaManager" :assignable-id="form.client_id" @selected="form.logo = $event" image-size="large" />

    <deletion-modal
      v-if="showDeleteModal"
      @confirmed="deleteCampaign"
      @leave="showDeleteModal = false"
      @dismissed="showDeleteModal = false">
      <p class="text-center">Are you sure you want to permanently delete this campaign? It cannot be recovered once deleted.</p>
    </deletion-modal>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import moment from 'moment'
import EzineMediaManager from '@/components/Ezines/EzineMediaManager.vue'
import DeletionModal from '@/components/Modals/DeletionModal'
import { mapActions } from 'vuex'

export default {
  components: { EzineMediaManager, DeletionModal },
  props: ['errorBag', 'value'],
  data () {
    return {
      form: this.value,
      fonts: ['Lato', 'Merriweather', 'Montserrat', 'Roboto'],
      fontWeights: [
        { value: 100, name: 'Thin' },
        { value: 300, name: 'Light' },
        { value: 400, name: 'Regular' },
        { value: 700, name: 'Bold' },
        { value: 900, name: 'Black' }
      ],
      newProofingAddress: null,
      newRecipient: null,
      showDeleteModal: false
    }
  },
  computed: {
    now () {
      return moment().local()
    },
    active: {
      get () {
        return this.form.deleted_at === null
      },
      set (selected) {
        return selected ? null : this.now
      }
    },
    themePreview () {
      const fontImport = `family=${this.form.font_headings}:wght@${this.form.font_headings_weight}&family=${this.form.font_body}:wght@400`
      const uppercase = this.form.font_headings_uppercase ? 'text-transform:uppercase;' : ''
      return `<!DOCTYPE HTML><html><head><link href="https://fonts.googleapis.com/css2?${fontImport}&display=swap" rel="stylesheet"><style>*{padding:0;margin:0}body{font-family:"${this.form.font_body}";font-size:.875rem;line-height:1.5}h1{color:${this.form.colour1};font-family:"${this.form.font_headings}";margin-bottom:.75rem;${uppercase}}p{margin-bottom:1.5rem}button{background-color:${this.form.colour1};color:#FFF;padding:.5rem 1rem;border-radius:.25rem;display:block;margin:0px auto;border:none;font:inherit}</style></head><body><h1>Heading</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sit amet vulputate orci, sit amet blandit ex. Quisque sed dui nec diam cursus pretium eget et lacus. Fusce porta pellentesque magna vitae interdum. Pellentesque imperdiet ex et purus fermentum, vel feugiat mauris placerat.</p><div><button type="button">Example Button</button></div></body></html>`
    }
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    addProofingAddress () {
      const newAddress = this.newProofingAddress.trim().toLowerCase()
      if (newAddress && !this.form.proofing_email_addresses.includes(newAddress)) {
        this.form.proofing_email_addresses.push(newAddress)
      }
      this.newProofingAddress = null
    },
    removeProofingAddress (address) {
      this.form.proofing_email_addresses.splice(this.form.proofing_email_addresses.indexOf(address), 1)
    },
    addRecipient () {
      const newAddress = this.newRecipient.trim().toLowerCase()
      if (newAddress && !this.form.recipients.includes(newAddress)) {
        this.form.recipients.push(newAddress)
      }
      this.newRecipient = null
    },
    removeRecipient (address) {
      this.form.recipients.splice(this.form.recipients.indexOf(address), 1)
    },
    deleteCampaign () {
      v2Api.delete(`ezine-campaigns/${this.form.id}`, {
        params: {
          force: 1
        }
      }).then(() => {
        this.$emit('back')

        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Deleted',
          info: 'The campaign has been deleted.'
        })
      })
    }
  },
  watch: {
    form: {
      handler () {
        this.$emit('input', this.form)
      },
      deep: true
    }
  }
}
</script>
